/** Avisos mostrados en NotificationBar (páginas y modal de auth). */
export const AUTH_NOTICE = {
  LOGOUT_SUCCESS: 'logout-success',
  SESSION_EXPIRED: 'session-expired',
}

export const AUTH_NOTICE_QUERY_PARAM = 'auth'
export const AUTH_NOTICE_QUERY_LOGOUT = 'logout'
